import { Controller } from "@hotwired/stimulus"
import { Popover } from "bootstrap"

export default class extends Controller {
  static values = {
    content: String,
    placement: { type: String, default: 'top' }
  }

  connect() {
    this.popover = new Popover(this.element, {
      trigger: 'hover focus',
      html: false,
      placement: this.placementValue,
      content: this.contentValue || ''
    })
  }

  disconnect() {
    this.popover?.dispose()
  }
}
